import { Navigate } from "react-router-dom";

/** Old sidebar paths → where they live now. Seller bookmarks, product-tour
 *  steps and links inside already-sent emails all still point at the left
 *  column, so each one must land on the real destination rather than a 404.
 *  `notice` names the i18n string for the one-time "this moved" banner.
 *
 *  Kept free of icon/i18n imports on purpose: App.tsx is the entry chunk, and
 *  buyers loading a storefront must not pay for dashboard chrome. */
export const MOVED_ROUTES: { from: string; to: string; notice: string }[] = [
  { from: "setup", to: "/dashboard/overview?tab=sedia", notice: "nav.moved.setup" },
  { from: "bonus-review", to: "/dashboard/products?tab=review", notice: "nav.moved.bonus" },
  { from: "abandoned", to: "/dashboard/orders?tab=troli", notice: "nav.moved.abandoned" },
  { from: "access", to: "/dashboard/orders?tab=akses", notice: "nav.moved.access" },
  { from: "discounts", to: "/dashboard/marketing?tab=diskaun", notice: "nav.moved.discounts" },
  { from: "teams", to: "/dashboard/marketing?tab=team", notice: "nav.moved.teams" },
  { from: "affiliates", to: "/dashboard/affiliate", notice: "nav.moved.affiliates" },
  { from: "members", to: "/dashboard/settings?tab=ahli", notice: "nav.moved.members" },
  { from: "billing", to: "/dashboard/langganan", notice: "nav.moved.billing" },
];

export function MovedRoute({ to, notice }: { to: string; notice: string }) {
  return <Navigate to={to} replace state={{ movedNotice: notice }} />;
}
